import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const  routes=[
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/components/common/home.vue'),
      redirect:'/homeIndex',
      children:[
        {
          path:'/homeIndex',
          name:'homeIndex',
          component: () => import('@/components/page/work.vue'),
          meta: { title:'首页'}
        },
        {
          path:'/Supplier_Account',
          name:'Supplier_Account',
          component: () => import('@/components/page/Manage/PO.vue'),
          meta: { title:'供应商管理'}
        },
        {
          path:'/Material',
          name:'Material',
          component: () => import('@/components/page/Manage/manageMaterial.vue'),
          meta: { title:'物料管理'}
        },
        {
          path:'/Supplier_Material',
          name:'Supplier_Material',
          component: () => import('@/components/page/AOG.vue'),
          meta: { title:'供应商物料'},
        },
        {
          path:'/Delivery_BarCode',
          name:'Delivery_BarCode',
          component: () => import('@/components/page/deploy.vue'),
          meta: { title:'供应商打码'},
        },
        {
          path:'/Roles',
          name:'role',
          component: () => import('@/components/page/Manage/mesRole.vue'),
          meta: { title:'角色管理'},
        },
        {
          path:'/Modules',
          name:'modules',
          component: () => import('@/components/page/Manage/mesModules.vue'),
          meta: { title:'模块管理'},
        },
        {
          path:'/Dictionarys',
          name:'dictionarys',
          component: () => import('@/components/page/Manage/mesDD.vue'),
          meta: { title:'字典管理'},
        },
        {
          path:'/PAUsers',
          name:'mesUser',
          component: () => import('@/components/page/Manage/mesUser.vue'),
          meta: { title:'用户管理'},
        },
        {
          path:'/PoOrder',
          name:'poOrder',
          component: () => import('@/components/page/Purchase/PoOrder.vue'),
          meta: { title:'采购订单'},
        },
        {
          path:'/Supplier_Order',
          name:'SupplierOrder',
          component: () => import('@/components/page/Purchase/SupplierOrder.vue'),
          meta: { title:'供应商订单'},
        },
        {
          path:'/Supplier_Deliver',
          name:'SupplierDeliver',
          component: () => import('@/components/page/Purchase/SupplierDeliver.vue'),
          meta: { title:'供应商发货'},
        },
        {
          path:'/Supplier_Receiving_Record',
          name:'SupplierReceivRecord',
          component: () => import('@/components/page/Purchase/SupplierReceivRecord.vue'),
          meta: { title:'采购到货记录'},
        },
       {
          path:'/Supplier_Quality_Upload',
          name:'SupplierQualityUpload',
          component: () => import('@/components/page/SupplierSystem/QualityUpload.vue'),
          meta: { title:'供应商资质上传'},
        },
        {
          path:'/Supplier_Performance',
          name:'SupplierPerformance',
          component: () => import('@/components/page/SupplierSystem/Performance.vue'),
          meta: { title:'供应商绩效评估'},
        },
       {
          path:'/Supplier_Evaluate_Search',
          name:'SupplierEvaluateSearch',
          component: () => import('@/components/page/SupplierSystem/EvaluateSearch.vue'),
          meta: { title:'供应商评价查询'},
        },
        {
           path:'/Supplier_Message_Correct',
           name:'messageCorrect',
           component: () => import('@/components/page/SupplierSystem/messageCorrect.vue'),
           meta: { title:'供应商信息更正'},
        },
        {
            path:'/Supplier_Qualification',
            name:'qualification',
            component: () => import('@/components/page/SupplierSystem/qualification.vue'),
            meta: { title:'供应商资质认证'},
        },
        {
            path:'/Drawing_drawingRepair',
            name:'drawingRepair',
            component: () => import('@/components/page/drawing/drawingRepair.vue'),
            meta: { title:'物料图纸维护'},
        },
        {
            path:'/Drawing_drawingAffirm',
            name:'drawingAffirm',
            component: () => import('@/components/page/drawing/drawingAffirm.vue'),
            meta: { title:'供应商图纸确认'},
        },
        {
            path:'/Closing_closingPayment',
            name:'closingPayment',
            component: () => import('@/components/page/closing/closingPayment.vue'),
            meta: { title:'供应商对账'},
        },
        {
            path:'/Closing_closings',
            name:'closings',
            component: () => import('@/components/page/closing/closings.vue'),
            meta: { title:'供应商结算'},
        },
        {
            path:'/Closing_closingAccount',
            name:'closingAccount',
            component: () => import('@/components/page/closing/closingAccount.vue'),
            meta: { title:'供应商台账'},
        },
        {
            path:'/Closing_closingBill',
            name:'closingBill',
            component: () => import('@/components/page/closing/closingBill.vue'),
            meta: { title:'供应商付款'},
        },
        {
            path:'/Closing_closingPlan',
            name:'closingPlan',
            component: () => import('@/components/page/closing/closingPlan.vue'),
            meta: { title:'付款进度查询'},
        },
        {
            path:'/Mould_mouldOpen',
            name:'mouldOpen',
            component: () => import('@/components/page/mouldManage/mouldOpen.vue'),
            meta: { title:'模具开模管理'},
        },
        {
            path:'/Mould_mouldOpenAffirm',
            name:'mouldOpenAffirm',
            component: () => import('@/components/page/mouldManage/mouldOpenAffirm.vue'),
            meta: { title:'模具开模确认'},
        },
        {
            path:'/Mould_mouldRegister',
            name:'mouldRegister',
            component: () => import('@/components/page/mouldManage/mouldRegister.vue'),
            meta: { title:'模具信息登记'},
        },
        {
            path:'/Mould_mouldSearch',
            name:'mouldSearch',
            component: () => import('@/components/page/mouldManage/mouldSearch.vue'),
            meta: { title:'模具信息查询'},
        },
        {
          path:'/dv',
          name:'dv',
          component: () => import('@/components/page/dv/main.vue'),
          meta: { title:'通用视图配置'},
        },
        {
          path:'/report',
          name:'report',
          component: () => import('@/components/page/report/index.vue'),
          meta: { title:'统计报表'},
        },
        {
          path:'/inv',
          name:'inv',
          component: () => import('@/components/page/report/Inventory.vue'),
          meta: { title:'库存缺料查询'},
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/login/login.vue'),
    },
    {
      path: '/lost',
      name: 'lost',
      component: () => import('@/components/login/lost.vue'),
    },
    {
      path: '/changePw',
      name: 'changePw',
      component: () => import('@/components/login/changePw.vue'),
    },

]
const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
// const router = new VueRouter({ ... })
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  }else if(to.path === '/lost'||to.path === '/changePw'){
    next();
  }else{
    let token = sessionStorage.getItem('Authorization');
    if (token === null || token === '') {
      next('/login');
    } else {
      next();
    }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js